import styled from "styled-components";
import { Dropdown } from "discover.medical.react-component-library";

export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`;
